"use client";

import dynamic from "next/dynamic";

const SectionEditorModal = dynamic(() => import("@/components/edit-mode/SectionEditorModal"), {
  ssr: false,
});

export default function LazySectionEditorModal() {
  return <SectionEditorModal />;
}
